export default "__VITE_ASSET__C0rsY7JM__"